import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import {
  ClientsDownload,
  MapStormDatePickerModal,
  MapNameFilterModal,
  Checkbox
 } from 'components';

import * as Actions from 'actions';

class ClientsOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_storm_date_picker : false,
      show_name_input : false
    }

    this.handleClickCreateClient = this.handleClickCreateClient.bind(this);
    this.handleClickToggleFilterByBounds = this.handleClickToggleFilterByBounds.bind(this);
  }

  handleClickCreateClient() {
    this.props.startCreatingClient({address : this.props.current_place ? parseAddress(this.props.current_place) : {}});
  }
  handleClickToggleFilterByBounds() {
    const { filter_table_by_map_bounds } = this.props.clients;
    if(localStorage) {
      localStorage.setItem('filter_clients_by_map_bounds', filter_table_by_map_bounds ? 'false' : 'true');
    }
    this.props.toggleFilterClientsByMapBounds(!filter_table_by_map_bounds)
  }

  render() {
    const { fetching_filters, fetching_clients, filter_table_by_map_bounds, clients_table_open_state } = this.props.clients;
    const { pathname } = this.props.routing.locationBeforeTransitions;

    return (
      <div className='clients-options-container'>
        <Button
          onClick={this.props.clearClientsFilters}
          bsStyle='warning'
          >
          Clear Filters
        </Button>
        <span className='ml-sm'>
          <DropdownButton
            id='clients-options-dropdown'
            pullRight={this.props.pull_right == true}
            title={this.props.title || 'Map Options'}
            >
            <MenuItem onSelect={this.handleClickCreateClient}>
              {fetching_filters || fetching_clients ?
                <div><i className='fa fa-spinner fa-spin' /> Loading</div> :
                <div><i className='fa fa-plus' /> Client</div>}
            </MenuItem>
            {this.props.show_column_selection !== false ? (
              <MenuItem onSelect={this.props.showSelectingClientColumns}>
                <i className='fa fa-columns' /> Select Columns
              </MenuItem>
            ) : null}
            {this.props.show_storm_date_picker !== false ? (
              <MenuItem onSelect={() => {this.setState({show_storm_date_picker : true})}}>
                <i className='fa fa-calendar' /> Impact Date Filter
              </MenuItem>
            ) : null}
            {this.props.show_name_filter !== false ? (
              <MenuItem onSelect={() => {this.setState({show_name_input : true})}}>
                <i className='fa fa-font' /> Name Filter
              </MenuItem>
            ) : null}
          </DropdownButton>
        </span>
        <span className='ml-sm'>
          <ClientsDownload />
        </span>
        {/^clients\/map/.test(pathname) && clients_table_open_state == 'open'? (
          <Checkbox
            id='clients-filter-by-bounds-toggle'
            onChange={this.handleClickToggleFilterByBounds}
            checked={filter_table_by_map_bounds != false}
            label='Filter Table by the Map Boundaries'
            style={{ float: 'right' }}
          />
        ) : null}

        <MapStormDatePickerModal
          handleOnHide={() => this.setState({show_storm_date_picker : false})}
          show={this.state.show_storm_date_picker}
        />

        <MapNameFilterModal
          handleOnHide={() => {this.setState({show_name_input : false})}}
          show={this.state.show_name_input}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ clients, routing }) => ({ clients, routing });

export default connect(mapStateToProps, Actions)(ClientsOptions);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-options.js